/**
 * Contributors whose Sanity author slug differs from their WordPress login.
 * Their WordPress reveals are still filed under the old handle, so a listing
 * at the new slug asks WordPress for the old one until the posts move. The
 * /team-reveals redirects in next.config.js mirror this map (FFH-2873).
 */
export const LEGACY_TEAM_REVEAL_HANDLES: Readonly<Record<string, string>> = {
  fplsalah: 'mario8787',
  fplmatthew: 'mj6987',
  fplheisenberg: 'fpl_heisenberg',
  fergi: 'fergi222',
  hollyshand: 'ffcommunity_'
};

export const resolveWordPressAuthorHandle = (authorSlug: string): string =>
  LEGACY_TEAM_REVEAL_HANDLES[authorSlug] ?? authorSlug;
